import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
// import AgenciesTable from "./AgenciesTable";
import AgenciesNewList from "../Agencies/AgenciesNewList";

function Agencies() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Agencies</h1>
            <Button
              className="contentTopLefBt"
              onClick={() => navigate("/AddAgency")}
            >
              Add Agency
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <AgenciesTable /> */}
              <AgenciesNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default Agencies;
